import { ReactNode } from 'react';

export function joinNodes(
    nodes: ReactNode[],
    separator: ReactNode,
    useAnd?: boolean
): ReactNode {
    return nodes.length === 0
        ? undefined
        : nodes.reduce((node1, node2, index) => (
              <>
                  {node1}
                  {separator}
                  {useAnd && index === nodes.length - 2 && ' and '}
                  {node2}
              </>
          ));
}
